export const SiderCollapsedKey = Symbol('siderCollapsed');
export const SiderHookProviderKey = Symbol('siderHookProvider');
